import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "omni_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fileToDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });

let mediaToken = "";
export const setMediaToken = (t) => { mediaToken = t || ""; };
export const fetchMediaToken = async () => {
  const { data } = await api.get("/auth/media-token");
  setMediaToken(data.token);
  return data.token;
};
export const favoriteImageUrl = (id) => `${API}/favorites/${id}/image?auth=${encodeURIComponent(mediaToken)}`;
export const videoStreamUrl = (id) => `${API}/videos/${id}/stream?auth=${encodeURIComponent(mediaToken)}`;

export async function streamMessage(convId, body, handlers) {
  return streamSSE(`${API}/conversations/${convId}/messages`, body, handlers);
}

export async function streamCompare(body, handlers) {
  return streamSSE(`${API}/compare`, body, handlers);
}

async function streamSSE(url, body, handlers) {
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    let detail = `Request failed (${res.status})`;
    try { detail = formatApiError({ response: { data: await res.json() } }); } catch (_) {}
    throw new Error(detail);
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const parts = buffer.split("\n\n");
    buffer = parts.pop();
    for (const part of parts) {
      const line = part.split("\n").find((l) => l.startsWith("data: "));
      if (!line) continue;
      const evt = JSON.parse(line.slice(6));
      handlers[evt.type]?.(evt);
    }
  }
}
